import NsContent from 'components/common/ns-content/NsContent';

type RowTitleProps = {
  children?: React.ReactNode;
  colSpan?: number;
};

export const RowTitle = ({ children, colSpan }: RowTitleProps) => (
  <tr>
    <td colSpan={colSpan}>
      <NsContent spacing="compact">
        <p className="p-caption">
          <b>{children}</b>
        </p>
      </NsContent>
    </td>
  </tr>
);
